export default {
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.articles": "Guides",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Guide d'achat",
  "nav.homeBtn": "Accueil",

  "hero.badge": "Ressource d'achat indépendante",
  "hero.title": "USFans Spreadsheet : trouvez produits, vendeurs et ressources d'achat plus vite",
  "hero.subtitle": "Explorez la feuille USFans Spreadsheet, découvrez produits et vendeurs, comparez des ressources utiles et informez-vous sur la livraison, l'entrepôt, le contrôle qualité et la sécurité d'achat.",
  "hero.ctaPrimary": "Explorer USFans Spreadsheet",
  "hero.ctaSecondary": "Voir les guides",
  "hero.searchPlaceholder": "Recherchez dans USFans Spreadsheet, produits, vendeurs ou catégories...",

  "cta.usfans": "usfans spreadsheet",
  "cta.buynow": "achetez maintenant",

  "categories.dropdownLabel": "Choisissez une catégorie",
  "categories.title": "Parcourir par catégorie",
  "categories.subtitle": "Choisissez une catégorie ci-dessous pour accéder directement aux produits correspondants de la boutique principale.",

  "cat.shoes": "Chaussures",
  "cat.hoodies": "Hoodies / Sweats",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements / Caleçons",
  "cat.jersey": "Maillot",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  "articles.title": "Derniers guides et ressources",
  "articles.subtitle": "Des guides originaux pour vous aider à acheter plus intelligemment avec USFans Spreadsheet.",
  "articles.readMore": "Lire l'article",
  "articles.minRead": "min de lecture",

  "content.title": "Qu'est-ce que la feuille USFans Spreadsheet ?",
  "content.p1": "La feuille USFans Spreadsheet est une référence pratique qui rassemble les catégories de produits et les liens des vendeurs au même endroit. Au lieu de chercher sur le web, vous ouvrez une catégorie et accédez directement à ce que vous cherchez, des chaussures et sweats aux sacs, ceintures et parfums.",
  "content.p2": "Chaque catégorie pointe vers une page dédiée de la boutique principale, si bien que vous arrivez toujours là où se trouvent réellement les produits. Cela rend la navigation plus rapide et garde tout organisé par type.",
  "content.cta": "Ouvrir la feuille USFans Spreadsheet",

  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides sur le fonctionnement de la feuille USFans Spreadsheet.",

  "safety.title": "Achetez en toute confiance",
  "safety.text": "Ceci est une ressource d'information indépendante. Vérifiez toujours les détails du produit, les prix et la livraison directement sur la boutique avant d'acheter.",
  "safety.disclaimer": "USFansLink.club est une ressource d'information indépendante et ne doit pas être présenté comme le site officiel d'USFans à moins qu'une relation officielle n'ait été vérifiée.",

  "footer.disclaimer": "USFansLink.club est une ressource d'information indépendante et n'est affilié ni approuvé par aucune boutique mentionnée. Tous les liens externes s'ouvrent dans un nouvel onglet.",
  "footer.rights": "Tous droits réservés.",

  "article.back": "Retour à l'accueil",
  "article.updated": "Dernière mise à jour",
  "article.pros": "Avantages",
  "article.cons": "Inconvénients",
  "article.faq": "FAQ",
  "article.related": "Guides associés",
  "article.ctaTitle": "Prêt à explorer ?",
  "article.ctaText": "Accédez à la feuille USFans Spreadsheet et commencez à parcourir produits et vendeurs.",
  "article.ctaButton": "Ouvrir USFans Spreadsheet",
};